import React from 'react';
import { formatCurrency, formatNumber, formatWeight } from '../../utils/helpers';
import { ShoppingCart, X, History, Edit2 } from 'lucide-react';

function ViewSaleModal({ sale, onClose, onEdit, setViewImage, onViewHarvests }) {
  if (!sale) return null;
  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title-group">
            <ShoppingCart size={24} />
            <h3>Sale Details</h3>
          </div>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginBottom: '2rem' }}>
          <button className="action-btn sm" onClick={() => { onClose(); onViewHarvests(sale.tally_sheet_number); }}>
            <History size={14} style={{marginRight: '6px'}} /> Agents
          </button>
          <button className="action-btn sm" onClick={() => onEdit(sale)}>
            <Edit2 size={14} style={{marginRight: '6px'}} /> Edit
          </button>
        </div>

        <div className="details-grid">
          <div className="details-column">
            <p><strong>Date:</strong> {new Date(sale.date).toLocaleString()}</p>
            <p><strong>Tally #:</strong> <span className="highlight">{sale.tally_sheet_number}</span></p>
            <p><strong>Buyer:</strong> <strong>{sale.buyer}</strong></p>
            <p><strong>Location:</strong> {sale.location_name || '-'}</p>
          </div>
          <div className="details-column">
            <p><strong>Heads:</strong> {formatNumber(sale.number_of_heads)}</p>
            <p><strong>Weight:</strong> {formatWeight(sale.kilos)}</p>
            <p><strong>Total:</strong> <span className="status-paid">{formatCurrency(sale.total_sales)}</span></p>
            <p><strong>Status:</strong> <span className={sale.paid ? 'status-paid' : 'status-error'}>{sale.paid ? 'Paid' : 'Unpaid'}</span></p>
          </div>
        </div>

        {sale.notes && (
          <div className="notes-section" style={{marginTop: '1.5rem', padding: '1.5rem', background: 'var(--google-grey-50)', borderRadius: 'var(--border-radius-md)'}}>
            <strong>Notes:</strong>
            <p style={{margin: '0.5rem 0 0 0', color: 'var(--text-secondary)', lineHeight: '1.6'}}>{sale.notes}</p>
          </div>
        )}

        {sale.tally_sheet_picture && (
          <div className="picture-section" style={{marginTop: '1.5rem'}}>
            <p><strong>Tally Sheet Picture:</strong></p>
            <div className="image-container" style={{marginTop: '0.75rem'}}>
              <img 
                src={sale.tally_sheet_picture} 
                alt="Tally Sheet" 
                onClick={() => setViewImage(sale.tally_sheet_picture)} 
                style={{ borderRadius: 'var(--border-radius-md)', border: '1px solid var(--border-color)', cursor: 'pointer', maxWidth: '100%' }}
              />
            </div>
          </div>
        )}

        <div className="form-actions">
          <button onClick={onClose} className="secondary-btn">Close</button>
        </div>
      </div>
    </div>
  );
}

export default ViewSaleModal;
